export default __webpack_public_path__ + "static/media/icon_orient.618061a3.svg";